import { TSellerOtherItemsData } from 'types/TSellerOtherItem';
import fetchAPI from '../utils/fetchAPI';

type TParams = {
  sellerId: number;
  itemId: string;
  categoryId: number;
};

export default function getSellerOtherItems({ sellerId, itemId, categoryId }: TParams): Promise<TSellerOtherItemsData> {
  try {
    const sellerIdEncoded = encodeURIComponent(sellerId);
    const itemIdEncoded = encodeURIComponent(itemId);
    const l2CategoryIdEncoded = encodeURIComponent(categoryId);

    return fetchAPI({
      url: `/v/api/seller-other-items?sellerId=${sellerIdEncoded}&itemId=${itemIdEncoded}&l2CategoryId=${l2CategoryIdEncoded}`,
    });
  } catch {
    return Promise.resolve({ items: [], total: 0 }) as Promise<TSellerOtherItemsData>;
  }
}
